import React from 'react';
import { Gift } from 'lucide-react';
import { motion } from 'framer-motion';
export const Bonuses = () => {
  return <section className="py-20 px-4 bg-brand-teal text-white" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <div className="text-center mb-12" data-id="element-13">
          <span className="inline-block bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-sm mb-4 animate-bounce" data-id="element-14">
            ¡GRATIS POR EL DÍA DE HOY!
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-cream" data-id="element-15">
            OFERTA ESPECIAL: BONUS PROFESIONALES INCLUIDOS CON TU COMPRA
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-16">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white text-brand-teal-dark rounded-2xl p-8 relative shadow-xl" data-id="element-17">
            <div className="absolute -top-4 -right-4 bg-brand-gold text-white font-bold text-sm px-4 py-2 rounded-full shadow-lg transform rotate-3" data-id="element-18">
              ¡Incluido hoy!
            </div>
            <div className="flex items-center gap-3 mb-6" data-id="element-19">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-20" />
              <h3 className="font-serif font-bold text-xl" data-id="element-21">BONUS #1</h3>
            </div>
            <h4 className="font-bold text-lg border-b pb-4 border-gray-100" data-id="element-22">
              Guía de Psicoeducación para Pacientes con TCA
            </h4>
            <p className="text-gray-600 mt-4 text-sm" data-id="element-23">
              Documento descargable listo para entregar al paciente en las
              primeras sesiones.
            </p>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white text-brand-teal-dark rounded-2xl p-8 relative shadow-xl" data-id="element-24">
            <div className="absolute -top-4 -right-4 bg-brand-gold text-white font-bold text-sm px-4 py-2 rounded-full shadow-lg transform rotate-3" data-id="element-25">
              ¡Incluido hoy!
            </div>
            <div className="flex items-center gap-3 mb-6" data-id="element-26">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-27" />
              <h3 className="font-serif font-bold text-xl" data-id="element-28">BONUS #2</h3>
            </div>
            <h4 className="font-bold text-lg border-b pb-4 border-gray-100" data-id="element-29">
              Pack de Herramientas Aplicables para Sesión y Familia
            </h4>
            <p className="text-gray-600 mt-4 text-sm" data-id="element-30">
              Documentos descargables listos para usar en sesión o como material
              de orientación familiar.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};